import { useQuery as defaultUseQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";

import {
  ApolloInjection,
  isAuthenticated as IsAuthenticatedQuery,
} from "@zapier/payment/esm/types";

export const isAuthenticatedQuery = gql`
  query isAuthenticated {
    isAuthenticated: isAuthenticatedV2
  }
`;

type Props = {
  skip?: boolean;
} & ApolloInjection;

export const useIsAuthenticated = ({ skip, ...props }: Props = {}) => {
  const useQuery = props.useQuery ?? defaultUseQuery;
  const { data, error, loading } = useQuery<IsAuthenticatedQuery>(
    isAuthenticatedQuery,
    {
      skip,
    }
  );

  return {
    error,
    isAuthenticated: Boolean(data?.isAuthenticated),
    isLoading: loading,
  };
};
